module.exports = __webpack_public_path__ + "static/img/10012 (3).4b9edf8.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10012 (3).webp
// module id = KVuy
// module chunks = 14